import { FC } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import classNames from 'classnames';

import Header from '../header';
import Menu from '../menu';
import { AppSupportChat } from '../../features/support/AppSupportChat';
import { useSupportAiBotFeatureFlag } from '../../features/support/useSupportAiBotFeatureFlag';

const Layout: FC = () => {
  const { pathname } = useLocation();
  const isJournal = pathname.startsWith('/journal');
  const isConsultations = pathname === '/consultations';
  const { enabled: isSupportAiBotEnabled } = useSupportAiBotFeatureFlag();

  return (
    <div className="h-full">
      <Header />
      <div className="layout">
        <div className="h-full flex flex-col lg:flex-row lg:items-stretch gap-[30px] pt-[10px] lg:pt-[10px]">
          <Menu />
          <main
            className={classNames(
              'flex-1 min-w-0',
              isJournal ? 'w-full overflow-x-clip pt-0' : isConsultations ? 'pt-2 sm:pt-6' : 'pt-6',
            )}
          >
            <Outlet />
          </main>
        </div>
      </div>
      {isSupportAiBotEnabled ? <AppSupportChat /> : null}
    </div>
  );
};

export default Layout;
